import { userAgent } from "@Core/utils/UserAgent";
export class IncognitoModeQualifier {
    constructor() {
        this.key = "IncognitoMode";
    }
    async process() {
        const incognito = await this.detect();
        return incognito ? "true" : "false";
    }
    async detect() {
        try {
            if (userAgent.isChrome()) {
                return await this.detectChromeIncognito();
            }
            else if (userAgent.isEdge()) {
                return await this.detectChromeIncognito(); // Edge Chromium
            }
            else if (userAgent.isFirefox()) {
                return navigator.serviceWorker === undefined;
            }
            else if (userAgent.isIE()) {
                try {
                    return !window.indexedDB;
                }
                catch (_a) {
                    return true;
                }
            }
            else if (userAgent.isSafari()) {
                return await this.detectSafari();
            }
            else {
                return false;
            }
        }
        catch (_b) {
            return false;
        }
    }
    detectChromeIncognito() {
        const version = parseInt(userAgent.getBrowserVersion());
        if (version >= 76)
            return this.detectChromeAfterVersion76();
        if (version > 74)
            return this.detectChromeAfterVersion74();
        return this.detectChromeBeforeVersion74();
    }
    detectChromeBeforeVersion74() {
        return new Promise((resolve) => {
            const fs = window.RequestFileSystem || window.webkitRequestFileSystem;
            if (!fs)
                return resolve(false);
            fs(window.TEMPORARY, 1, () => resolve(false), () => resolve(true));
        });
    }
    detectChromeAfterVersion74() {
        return new Promise((resolve) => {
            if ("storage" in navigator && "estimate" in navigator.storage) {
                navigator.storage.estimate().then((estimate) => {
                    var _a;
                    resolve(((_a = estimate.quota) !== null && _a !== void 0 ? _a : 1e9) < 120000000);
                }).catch(() => resolve(false));
            }
            else {
                resolve(false);
            }
        });
    }
    detectChromeAfterVersion76() {
        return new Promise((resolve) => {
            if ("storage" in navigator && "estimate" in navigator.storage) {
                navigator.storage.estimate().then((estimate) => {
                    var _a;
                    const quota = (_a = estimate.quota) !== null && _a !== void 0 ? _a : 1073741824; // 1GB default
                    // Mac / Chrome OS get different default quotas
                    const maxQuota = /Mac OS/.test(navigator.userAgent) && !/iPhone/.test(navigator.userAgent) || /CrOS/.test(navigator.userAgent)
                        ? 3221225472
                        : 1073741824;
                    resolve(quota < maxQuota);
                }).catch(() => resolve(false));
            }
            else {
                resolve(false);
            }
        });
    }
    detectSafari() {
        const version = parseInt(userAgent.getBrowserVersion());
        if (version >= 13) {
            return this.detectSafariAfter13();
        }
        return new Promise((resolve) => {
            try {
                window.localStorage.setItem("test", "1");
                if (window.openDatabase)
                    window.openDatabase(null, null, null, null);
                resolve(false);
            }
            catch (_a) {
                resolve(true);
            }
        });
    }
    detectSafariAfter13() {
        return new Promise((resolve) => {
            try {
                const tmp = `tmp${Math.random()}`;
                const req = window.indexedDB.open(tmp, 1);
                req.onupgradeneeded = function (event) {
                    const db = event.target.result;
                    try {
                        db.createObjectStore("test").put(new Blob());
                        resolve(false);
                    }
                    catch (e) {
                        resolve(/BlobURLs are not yet supported/.test(e.message || ""));
                    }
                    finally {
                        db.close();
                        window.indexedDB.deleteDatabase(tmp);
                    }
                };
                req.onerror = () => resolve(true);
            }
            catch (_a) {
                resolve(true);
            }
        });
    }
}
